import * as Yup from 'yup'
import { Formik, FormikHelpers } from 'formik'
import FormikFormattedTextField from '@ui-components-3/compat/lib/components/FormikFormattedTextField'
import useDocumentTitle from 'hooks/useDocumentTitle'
import { accessCodeInputFormat, cleanAccessCodeInput } from 'util/formatters'
import TestIds from 'util/TestIds'
import EntryFormCard from '../EntryFormCard'
import { VerifyMfaValues, VerifyMfaSchema } from 'schemas/VerifyMfaSchema'

export type VerifyMfaSceneProps = {
  onSubmit: (values: VerifyMfaValues, form: FormikHelpers<VerifyMfaValues>) => void
  onResend: () => void
  onBack: () => void
  onReselectMethod: () => void
}

const VerifyMfaScene = (props: VerifyMfaSceneProps) => {
  const { onSubmit, onResend, onBack, onReselectMethod } = props
  useDocumentTitle('Login Mfa')
  return (
    <EntryFormCard prompt={'MFA Required'}>
      <div className="mb-5">
        <p>Haven't received your verification code?</p>
        <div className="mt-1 flex items-center gap-1">
          <button
            className="typography-body text-primary cursor-pointer self-end font-semibold hover:underline"
            onClick={onResend}
            type="button"
            data-testid={TestIds.login.button.resendMfa}
          >
            Resend
          </button>
          <p>or</p>
          <button
            className="typography-body text-primary cursor-pointer self-end font-semibold hover:underline"
            onClick={onReselectMethod}
            type="button"
            data-testid={TestIds.login.button.reselectMfa}
          >
            Select a different method
          </button>
        </div>
      </div>
      <p className="typography-body self-start pb-4 text-start text-neutral-600">
        All fields marked with asterisks are required*
      </p>
      <Formik initialValues={{ mfaCode: '' }} validationSchema={VerifyMfaSchema} onSubmit={onSubmit}>
        {({ dirty, isValid, handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col items-center"
            data-testid={TestIds.login.form.verifyMfa}
          >
            <div data-testid={TestIds.login.input.verifyMfa} className="mb-9 w-full">
              <FormikFormattedTextField
                fullWidth
                label={'Verification Code'}
                schema={VerifyMfaSchema}
                name={'mfaCode'}
                unformatText={cleanAccessCodeInput}
                formatText={accessCodeInputFormat}
                className="[&_input]:text-center"
                autoComplete="off"
              />
            </div>
            <div className="mb-2 flex w-full items-center justify-between gap-4">
              <button
                className="btn btn-neutral-outlined grow"
                data-testid={TestIds.login.button.cancel}
                onClick={onBack}
                type="button"
              >
                Back
              </button>
              <button
                className="btn btn-primary grow"
                data-testid={TestIds.login.button.continue}
                disabled={!dirty || !isValid}
                type="submit"
              >
                Continue
              </button>
            </div>
          </form>
        )}
      </Formik>
    </EntryFormCard>
  )
}

export default VerifyMfaScene
